import { render, staticRenderFns } from "./CalculatingSpousalSupport.vue?vue&type=template&id=73ff1906"
import script from "./CalculatingSpousalSupport.vue?vue&type=script&lang=ts"
export * from "./CalculatingSpousalSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports